import React, { useState } from 'react'
import './Setting.scss'
import eyeopen from "../../../assets/icons/eye.svg"
import eyeclose from "../../../assets/icons/eyeclosed.svg"
const Setting = () => {
const [viewPass, setViewPass] = useState(false)

    return (
        <div className='setting-container'>
            <div className='w-100 d-flex justify-content-between'>
                <h3>Settings</h3>
                <p>Save Changes</p>
            </div>
            <div className='setting-inputs-box w-100 d-flex justify-content-between'>
                <h5>Username</h5>
                <input type='text' placeholder='Jack Adoms' />
            </div>
            <div className='setting-inputs-box w-100 d-flex justify-content-between'>
                <h5>Website</h5>
                <input type='text' placeholder='www.autored.com' />
            </div>
            <div className='setting-inputs-box w-100 d-flex justify-content-between'>
                <h5>Password</h5>
                <span>
                <input type={viewPass ? 'text': 'password'} placeholder='Type your password' />
                {viewPass ? (
                    <img src={eyeopen}
                    onClick={() => setViewPass(!viewPass)}/>
                ) :
                <img src={eyeclose} 
                onClick={() => setViewPass(!viewPass)}
                />
            }
            </span>
            </div>
        </div>
    )
}

export default Setting